import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import Lenis from '@studio-freight/lenis';

// Public Pages
import HomePage from './components/public/HomePage';
import AboutPage from './components/public/AboutPage';
import ServicesPage from './components/public/ServicesPage';
import GalleryPage from './components/public/GalleryPage';
import BookingPage from './components/public/BookingPage';
import PaymentPage from './components/public/PaymentPage';
import ContactPage from './components/public/ContactPage';
import LoginPage from './components/public/LoginPage';
import SignupPage from './components/public/SignupPage';
import VerifyEmailPage from './components/public/VerifyEmailPage';
import ForgotPasswordPage from './components/public/ForgotPasswordPage';
import ResetPasswordPage from './components/public/ResetPasswordPage';
import FAQPage from './components/public/FAQPage';
import PoliciesPage from './components/public/PoliciesPage';

// Customer Pages
import CustomerDashboard from './components/customer/CustomerDashboard';

// Admin Pages
import AdminDashboard from './components/admin/AdminDashboard';

// Protected Routes
import { ProtectedRoute, AdminRoute, CustomerRoute } from './components/shared/ProtectedRoute';

// Chat Widget
import ChatWidget from './components/shared/ChatWidget';
import WhatsAppButton from './components/shared/WhatsAppButton';

const App = () => {
  useEffect(() => {
    // Initialize Lenis smooth scrolling for public pages
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/policies" element={<PoliciesPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />

          {/* Customer Routes */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <CustomerDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/booking" 
            element={
              <CustomerRoute>
                <BookingPage />
              </CustomerRoute>
            } 
          />
          <Route 
            path="/payment" 
            element={
              <CustomerRoute>
                <PaymentPage />
              </CustomerRoute>
            } 
          />

          {/* Admin Routes */}
          <Route 
            path="/admin" 
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            } 
          />
        </Routes>
        <ChatWidget />
        <WhatsAppButton />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
    </HelmetProvider>
  );
};

export default App;
